import Extension from '@/tiptap/tiptap/Utils/Extension';
import {
  chainCommands,
  createParagraphNear,
  liftEmptyBlock,
  newlineInCode,
  splitBlock,
} from 'prosemirror-commands';
import { splitListItem } from 'prosemirror-schema-list';
import { splitToDefaultListItem } from '@/tiptap/commands/commands';

// what enter does when nothing takes it: carry on the list, or open the next block. An editor
// that sends on enter has to put this somewhere, and a break inside the block will not do —
// the input rules match from the start of a block, so a list typed after one never becomes a list
const splitContent = (schema) => chainCommands(
  ...(schema.nodes.todo_item === undefined ? [] : [splitToDefaultListItem(schema.nodes.todo_item)]),
  ...(schema.nodes.list_item === undefined ? [] : [splitListItem(schema.nodes.list_item)]),
  newlineInCode,
  createParagraphNear,
  liftEmptyBlock,
  splitBlock,
);

export default class EnterExtension extends Extension {
  constructor(options = {}) {
    super(options);
    this.enterHandlers = options.enterHandlers;
    this.ctrlEnterHandlers = options.ctrlEnterHandlers;
    this.modEnterHandlers = options.modEnterHandlers;
    this.shiftEnterHandlers = options.shiftEnterHandlers;
    this.splitKey = options.splitKey ?? 'Enter';
  }

  keys({ schema }) {
    const handleFn = (state, dispatch, view, handlers) => {
      if (!Array.isArray(handlers)) {
        return false;
      }

      let preventDefault = false;
      for (let i = 0; i < handlers.length; i++) {
        preventDefault = handlers[i](state, dispatch, view);
      }

      return preventDefault;
    };
    const keys = {
      Enter: (state, dispatch, view) => handleFn(state, dispatch, view, this.enterHandlers),
      'Ctrl-Enter': (state, dispatch, view) => handleFn(state, dispatch, view, this.ctrlEnterHandlers),
      'Mod-Enter': (state, dispatch, view) => handleFn(state, dispatch, view, this.modEnterHandlers),
      'Shift-Enter': (state, dispatch, view) => handleFn(state, dispatch, view, this.shiftEnterHandlers),
    };

    if (this.splitKey === 'Enter') {
      return keys;
    }

    const handled = keys[this.splitKey];
    const split = splitContent(schema);

    return {
      ...keys,
      [this.splitKey]: (state, dispatch, view) => handled(state, dispatch, view)
        || split(state, dispatch, view),
    };
  }
}
